// @ts-expect-error Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import PrimaryMessageAvatar from '../primary-message/components/PrimaryMessageAvatar';
import UIIconCircle from 'UIComponents/icon/UIIconCircle';
import { KOALA, EERIE } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
const AutomatedMessageAvatar = () => {
  return /*#__PURE__*/_jsx(PrimaryMessageAvatar, {
    children: /*#__PURE__*/_jsx(UIIconCircle, {
      name: "simpleBot",
      color: EERIE,
      backgroundColor: KOALA,
      borderWidth: 0,
      size: 16,
      padding: 0.5,
      legacy: true
    })
  });
};
AutomatedMessageAvatar.displayName = 'AutomatedMessageAvatar';
export default AutomatedMessageAvatar;